import { useCallback } from 'react';
import { useLocation, useNavigate, type NavigateOptions } from 'react-router-dom';

export const useNavigateWithSearch = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (to: string, options?: NavigateWithSearchOptions) => {
      const { removeSearchParams = [], ...navigateOptions } = options ?? {};

      // Start with current params, minus any that should be removed
      const mergedParams = new URLSearchParams();

      for (const [key, value] of new URLSearchParams(location.search).entries()) {
        if (!removeSearchParams.includes(key)) {
          mergedParams.append(key, value);
        }
      }

      // Destination params are merged in and take precedence over current ones
      const destination = new URL(to, window.location.origin);

      for (const [key, value] of destination.searchParams.entries()) {
        mergedParams.set(key, value);
      }

      const search = mergedParams.toString();
      const path = `${destination.pathname}${search ? `?${search}` : ''}${destination.hash}`;

      navigate(path, navigateOptions);
    },
    [navigate, location.search]
  );
};

type NavigateWithSearchOptions = NavigateOptions & {
  removeSearchParams?: string[];
};
